export interface FilterOption {
    label: string;
    value: string | number;
}

export interface FilterConfig {
    label: string;
    options: FilterOption[];
    defaultValue?: string | number;
    onChange?: (value: string | number) => void;
}

export interface LegendItem {
    label: string;
    color: string;
}

export type BplPriceMetricFamily = 'PPEQ' | 'PPU';
export type BplSalesMetric = 'Value' | 'Volume' | 'Units';

export interface BrandPriceLadderVizData {
    chart_type: 'BPL';
    chartTitle: string;
    xAxisTitle: string[];
    /**
     * New contract: nested families, e.g.
     * [["Sales Value", "Sales Volume", "Sales Units"], ["Avg PPEQ", ...], ["Avg PPU", ...]]
     * Legacy: flat array, e.g. ["Sales $", "Average Price", ...]
     */
    yAxisTitle: string[] | string[][];
    /** One header per y-axis family, e.g. ["Sales", "PPEQ", "PPU"] */
    yAxisHeaders?: string[];
    data: Array<{
        x: string[]; // X-axis values (brand names)
        /** Nested (new) or flat (legacy) y values aligned with yAxisTitle */
        y: number[] | Array<Array<number | null>>;
    }>;
}

/** True when viz_data uses the nested BPL contract with EQ/Units price families. */
export function isNestedBplVizData(vizData: BrandPriceLadderVizData | undefined): boolean {
    const yAxisTitle = vizData?.yAxisTitle;
    return Array.isArray(yAxisTitle) && yAxisTitle.length > 0 && Array.isArray(yAxisTitle[0]);
}

export interface BrandPriceLadderProps {
    // New format: viz_data (if provided, other props are optional)
    vizData?: BrandPriceLadderVizData;

    // Chart Title and Description
    title?: string;
    description?: string;

    // Filters
    filters?: FilterConfig[];

    // Footer
    footerLabel?: string;
    showFooterArrow?: boolean;

    // Callbacks
    onDownload?: () => void;
    onBarClick?: (...args: any[]) => void;
    onPointClick?: (...args: any[]) => void;

    /**
     * @deprecated BPL uses a categorical x-axis scrollbar (same as EnhancedBarChart category mode). This prop is ignored.
     */
    showSlider?: boolean;

    /** How many categories are visible in the x-axis scrollbar window at once. Default: 10 */
    scrollbarVisibleCount?: number;

    // Additional chart configurations
    sizeAttributes?: any;
    viewLevelAdditionalProps?: any;
    additionalMarks?: any[];

    // Custom styling
    className?: string;
    chartClassName?: string;

    // Test IDs
    'data-test'?: string;
    'data-test-id'?: string;
}


